import { Role } from '@mcper/core';
import { useAuthStore } from '../../store/auth.store';

const RANK: Record<Role, number> = { [Role.User]: 1, [Role.Admin]: 2 };

/** Whether the signed-in person holds at least this role (two roles: admin, the one bootstrap address, and user). */
export function hasRole(role: Role | undefined, minimum: Role): boolean {
  return role !== undefined && RANK[role] >= RANK[minimum];
}

export function useIsAdmin(): boolean {
  return useAuthStore((s) => hasRole(s.principal?.role, Role.Admin));
}

/** Where to send someone to look at an app's checks: its Tests page, for everyone. */
export function testsLink(slug: string): string {
  return `/tests/${slug}`;
}
